/**
 * Indica si un producto o formato de venta admite precio variable.
 */
export function isVariablePriceEnabled(value) {
	return value === true || value === 1 || value === 'SI' || value === 'si' || value === 'Si';
}

/**
 * Una línea de pedido admite cambio de precio si tiene precio variable, no está cobrada
 * y no está cancelada (-1), mermada (-3) ni rechazada (-4).
 */
export function canModifyProductOrderPrice(order) {
	if (!order) return false;
	if (!order.variablePrice) return false;
	if (order.paymentStatus === 1) return false;
	if ([-1, -3, -4].includes(order.statusProductOrder)) return false;
	return true;
}

export function parseOptionalPriceBound(value) {
	if (value === undefined || value === null || value === '') return null;
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : null;
}

/**
 * Límites comunes a varias líneas: el mayor de los mínimos y el menor de los máximos,
 * para que el precio introducido sea válido en todas ellas.
 */
export function intersectVariablePriceBounds(orders = []) {
	let min = null;
	let max = null;
	for (const order of orders) {
		const orderMin = parseOptionalPriceBound(order?.variablePriceMin);
		const orderMax = parseOptionalPriceBound(order?.variablePriceMax);
		if (orderMin !== null) min = min === null ? orderMin : Math.max(min, orderMin);
		if (orderMax !== null) max = max === null ? orderMax : Math.min(max, orderMax);
	}
	return { min, max };
}

/**
 * Staff-set variable price on a cart line. Reads `variablePriceValue`, then legacy `priceModify`
 * so carts persisted before the rename still send a price.
 */
export function cartLineVariablePriceValue(item) {
	if (!item) return null;
	const raw = item.variablePriceValue ?? item.priceModify;
	if (raw === undefined || raw === null || raw === '') return null;
	const parsed = Number(raw);
	return Number.isFinite(parsed) ? parsed : null;
}

/**
 * Resuelve flag, precio por defecto y límites a partir del producto y, si hay, del formato de venta.
 * El formato pisa el precio; variablePrice y min/max caen al producto si el formato no los declara.
 */
export function resolveVariablePriceInfo(product, sellingFormat = null) {
	const defaultPriceRaw = sellingFormat ? sellingFormat.price : product?.price;
	const variablePriceFlag =
		sellingFormat && sellingFormat.variablePrice != null ? sellingFormat.variablePrice : product?.variablePrice;
	const minSource = sellingFormat && sellingFormat.variablePriceMin != null ? sellingFormat : product;
	const maxSource = sellingFormat && sellingFormat.variablePriceMax != null ? sellingFormat : product;

	return {
		enabled: isVariablePriceEnabled(variablePriceFlag),
		productName: product?.name || '',
		defaultPrice: Number(defaultPriceRaw) || 0,
		min: parseOptionalPriceBound(minSource?.variablePriceMin),
		max: parseOptionalPriceBound(maxSource?.variablePriceMax),
	};
}
